import { useState } from "react";
import { Link } from "react-router-dom";
import { sharePostUrl, WhatsAppIcon } from "./WhatsAppIcon";

export const formatDate = (iso) =>
  new Date(iso).toLocaleDateString("en-IN", { day: "numeric", month: "long", year: "numeric" });

export const PostCard = ({ post }) => {
  const [src, setSrc] = useState(post.cover || "/assets/masterplan.webp");
  return (
    <Link
      to={`/blog/${post.slug}`}
      className="group flex h-full flex-col border border-border bg-paper-light transition-transform duration-200 hover:-translate-y-1"
      data-testid={`post-card-${post.slug}`}
    >
      <div className="h-44 overflow-hidden">
        <img
          src={src}
          onError={() => src !== "/assets/masterplan.webp" && setSrc("/assets/masterplan.webp")}
          alt={post.title}
          loading="lazy"
          className="h-full w-full object-cover transition-transform duration-500 group-hover:scale-105"
        />
      </div>
      <div className="flex flex-1 flex-col p-5">
        <p className="text-[11px] uppercase tracking-[0.18em] font-medium text-gold-dark">
          {formatDate(post.created_at)}
        </p>
        <h3 className="mt-2 font-display text-xl font-medium leading-snug text-forest transition-colors duration-200 group-hover:text-gold-dark">
          {post.title}
        </h3>
        {post.excerpt && (
          <p className="mt-2 line-clamp-3 text-sm leading-relaxed text-[#4A4C4A]">{post.excerpt}</p>
        )}
        <div className="mt-auto flex items-center justify-between pt-4">
          <span className="text-xs font-medium uppercase tracking-[0.14em] text-forest">
            Read article →
          </span>
          <span
            role="button"
            tabIndex={0}
            aria-label={`Share "${post.title}" on WhatsApp`}
            title="Share on WhatsApp"
            data-testid={`share-whatsapp-${post.slug}`}
            onClick={(e) => {
              e.preventDefault();
              e.stopPropagation();
              window.open(sharePostUrl(post), "_blank", "noopener");
            }}
            onKeyDown={(e) => {
              if (e.key === "Enter") {
                e.preventDefault();
                window.open(sharePostUrl(post), "_blank", "noopener");
              }
            }}
            className="cursor-pointer p-1 text-[#25D366] transition-transform duration-150 hover:scale-110"
          >
            <WhatsAppIcon className="h-4 w-4" />
          </span>
        </div>
      </div>
    </Link>
  );
};
